import { IsWebReference,IsWebReferenceSuffix } from "./Configuration";

export const isShortJourney = (webReference: string | null) => {
    if (!webReference)
        return "false";

    if (IsWebReferenceSuffix(webReference, "PO")
        || IsWebReferenceSuffix(webReference, "PI")
        || IsWebReferenceSuffix(webReference, "SI")
        || IsWebReferenceSuffix(webReference, "RPO")) {
        return "true";
    }
    return "false";
}